module.exports = __webpack_public_path__ + "images/sprites/tax_icons/tax_icon_category_fitness_868fa3b9c9e0a42d46f5dae5edb499cb.png";